import React, {Component} from 'react';
import '../App.css';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import Slider from "react-slick";
import ProjectSliderItem from "./ProjectSliderItem";

class ProjectSlider extends Component {
    render() {
        var settings = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 3,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        return (
            <div>
                <section id="more-projects">
                    <Slider {...settings}>
                        {this.props.projects ? this.props.projects.map((project, index) => <ProjectSliderItem key={index} id={project.id} image={project.image} title={project.title} slug={project.slug} tags={project.tags}/>) : null}
                    </Slider>
                </section>
            </div>
        );
    }
}

export default ProjectSlider;
